import { Button } from "reactstrap";

/**
 * FilterBar — wrapper for a list page's filter row.
 *
 * Drop existing selects / date pickers / search inputs in as children;
 * they get consistent gaps and wrap on small screens.
 *
 * Props:
 * - title:       optional page heading (h3)
 * - onClear:     optional handler — renders the Clear button when provided
 * - isFiltering: only show the Clear button while a filter is active
 * - children:    the filter controls
 * - className:   extra classes on the outer wrapper
 */
const FilterBar = ({ title, onClear, isFiltering, children, className = "" }) => {
  return (
    <div
      className={`akh-filter-bar d-flex flex-wrap align-items-center ${className}`.trim()}
    >
      {title && <h3 className="mb-0 mr-auto">{title}</h3>}
      {children}
      {onClear && isFiltering && (
        <Button type="button" color="danger" outline size="sm" onClick={onClear}>
          Clear
        </Button>
      )}
    </div>
  );
};

export default FilterBar;
